/* ⚠ Tooltip's sets with no "use client": a Server Component importing a value
   from ./tooltip.client gets an opaque client reference, not the object.
   tooltip.client.tsx imports these back from here rather than its own copy. */

export const TOOLTIP_PLACEMENTS = ["top", "bottom", "left", "right"] as const;
export type TooltipPlacement = (typeof TOOLTIP_PLACEMENTS)[number];
export type TooltipLinkTarget = "_self" | "_blank";

/** True for a value in `TOOLTIP_PLACEMENTS`; for anything else (a stray CMS
 *  value) callers fall back to Tooltip's own default, bottom. */
export function isTooltipPlacement(value: unknown): value is TooltipPlacement {
  return (
    typeof value === "string" &&
    (TOOLTIP_PLACEMENTS as readonly string[]).includes(value)
  );
}
